import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { clearQuickSearchCriteria, selectQuickSearchCriteria } from '../../../store/search'
import { getUrlBase } from '../../../utils/general'
import DetailSearchModal from './DetailSearchModal'

const DetailSearchButton = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { pathname } = useLocation()
    const dataKey = pathname.split('/')[1]
    const urlBase = getUrlBase(dataKey)

    const [detailSearchModal, setDetailSearchModal] = useState(false)
    const quickSearch = useSelector(selectQuickSearchCriteria)

    const handleModalOpen = () => {
        // clear quick search if exists
        if (quickSearch) {
            dispatch(clearQuickSearchCriteria())
        }

        setDetailSearchModal(true)
    }

    const toggleModal = () => {
        detailSearchModal ? setDetailSearchModal(false) : handleModalOpen()
    }

    return (
        <>
            <div className="header-item ms-4">
                <span className="btn btn-ghost-secondary text-white detail-search-button" onClick={toggleModal}>
                    {t('form.detailSearch.label')} <i className="mdi mdi-plus-circle ms-1"></i>
                </span>
            </div>
            {detailSearchModal && urlBase && <DetailSearchModal isOpen={detailSearchModal} toggle={toggleModal} type={urlBase} />}
        </>
    )
}

export default DetailSearchButton
